package com.parmartechnologies.core.feature.payment.status

enum class PaymentStatus {
    CREATED,
    INITIATED,
    IN_PROGRESS,
    AWAITING_CONFIRMATION,
    COMPLETED,
    FAILED,
}